import React from 'react';

const KeyContext = React.createContext<string>('');

export default KeyContext;
